import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Observable, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { LanguageService } from '@fcom/ui-translate';
import { unsubscribe } from '@fcom/core/utils';
import { PageMetaService } from '@fcom/common/services';
import { OndDataStream, OndPageType, OndPairEnhancedResponse } from '@fcom/ond-marketing-landing-core/interfaces';
import { OndMarketingOffersService } from '@fcom/ond-marketing-landing-core/services';
import { getCurrentCountry } from '@fcom/ond-marketing-landing-core/services/utils';

@Component({
  selector: 'fin-ond-marketing-listing',
  templateUrl: 'ond-marketing-listing.component.html',
  standalone: false,
})
export class OndMarketingListingComponent implements OnInit, OnDestroy {
  heading$: Observable<string>;
  ondStream$: Observable<OndDataStream>;
  pairs$: Observable<OndPairEnhancedResponse>;
  ondPageType: OndPageType = OndPageType.LISTING;
  private subscriptions: Subscription = new Subscription();

  constructor(
    readonly route: ActivatedRoute,
    private ondMarketingOffersService: OndMarketingOffersService,
    private languageService: LanguageService,
    private pageMetaService: PageMetaService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.pageMetaService.moveMetaAndLinksToHead([], this.renderer);

    if (this.languageService.langValue === 'en') {
      this.pairs$ = this.ondMarketingOffersService.fetchLocationPairs({
        originCountry: 'fi',
        lang: this.languageService.langValue,
      });
    } else {
      this.pairs$ = this.ondMarketingOffersService.fetchLocationPairs({
        originCountry: getCurrentCountry(this.languageService.langValue),
        lang: this.languageService.langValue,
      });
    }

    this.heading$ = this.route.data.pipe(
      switchMap((data) => {
        return this.languageService.translate(`ondMarketing.ribbon.${data.key}`);
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
